import cjs from "./rpc.cjs";
export const { RPC } = cjs;
